/* ShopSimple interactions: gallery, video reel, before/after, delivery dates, sticky add-to-cart, scroll reveal. */
(function () {
  if (window.SS_READY) return;
  window.SS_READY = true;
  document.documentElement.classList.add('ss-js');
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function once(el) { if (el.dataset.ssReady) return false; el.dataset.ssReady = '1'; return true; }

  function gallery(root) {
    if (!once(root)) return;
    var track = root.querySelector('[data-track]');
    var slides = $$(root, '[data-slide]');
    var thumbs = $$(root, '[data-thumb]');
    var count = root.querySelector('[data-count]');
    var cur = 0;
    if (!track || !slides.length) return;
    function mark(i) {
      cur = i;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      mark(i);
    }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== cur && i >= 0 && i < slides.length) mark(i);
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var p = root.querySelector('[data-prev]'), n = root.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { go(cur - 1); });
    if (n) n.addEventListener('click', function () { go(cur + 1); });
  }

  function reel(root) {
    if (!once(root)) return;
    var track = root.querySelector('[data-track]');
    if (!track) return;
    function step(dir) {
      var card = track.querySelector('.ss-reel__card');
      var w = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    var p = root.querySelector('[data-prev]'), n = root.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
    $$(root, '[data-mute]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.parentNode.querySelector('video');
        if (!v) return;
        var turnOn = v.muted;
        $$(root, 'video').forEach(function (o) { o.muted = true; });
        $$(root, '[data-mute]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); o.setAttribute('aria-label', 'Turn sound on'); });
        if (turnOn) {
          v.muted = false;
          b.setAttribute('aria-pressed', 'true');
          b.setAttribute('aria-label', 'Turn sound off');
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        }
      });
    });
  }

  function ba(root) {
    if (!once(root)) return;
    var r = root.querySelector('input[type="range"]');
    if (!r) return;
    function set() { root.style.setProperty('--pos', r.value + '%'); }
    r.addEventListener('input', set);
    set();
  }

  function addBiz(d, n) {
    var x = new Date(d.getTime()), added = 0;
    while (added < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) added++; }
    return x;
  }
  function ship(root) {
    if (!once(root)) return;
    var lang = document.documentElement.lang || undefined;
    function f(d) { try { return d.toLocaleDateString(lang, { month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString().slice(4, 10); } }
    function g(k) { return parseInt(root.getAttribute('data-' + k), 10) || 0; }
    var now = new Date();
    var o = root.querySelector('[data-d-order]'), s = root.querySelector('[data-d-ship]'), dl = root.querySelector('[data-d-deliver]');
    if (o) o.textContent = f(now);
    if (s) s.textContent = f(addBiz(now, g('ship-min'))) + ' – ' + f(addBiz(now, g('ship-max')));
    if (dl) dl.textContent = f(addBiz(now, g('del-min'))) + ' – ' + f(addBiz(now, g('del-max')));
  }

  function sticky(bar) {
    if (!once(bar)) return;
    var t = document.getElementById(bar.getAttribute('data-target'));
    if (!t || !('IntersectionObserver' in window)) return;
    function set(on) {
      bar.classList.toggle('is-on', on);
      if (on) { bar.removeAttribute('inert'); bar.setAttribute('aria-hidden', 'false'); }
      else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
    }
    set(false);
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { set(!e.isIntersecting && e.boundingClientRect.top < 0); });
    }).observe(t);
  }

  function product(root) {
    if (!once(root)) return;
    var variantSelect = root.querySelector('[data-ss-variant-select]');
    var variantId = root.querySelector('[data-ss-variant-id]');
    var sellingPlan = root.querySelector('[data-ss-selling-plan]');
    var planOptions = root.querySelector('[data-ss-plan-options]');
    var price = root.querySelector('[data-ss-price]');
    var compare = root.querySelector('[data-ss-compare]');
    var save = root.querySelector('[data-ss-save]');
    var stickyPrice = root.querySelector('[data-ss-sticky-price]');
    var oneTimePrice = root.querySelector('[data-ss-onetime-price]');

    function setPrice(priceValue, compareValue, saveLabel) {
      if (price && priceValue) price.textContent = priceValue;
      if (stickyPrice && priceValue) stickyPrice.textContent = priceValue;
      if (compare) { compare.textContent = compareValue || ''; compare.hidden = !compareValue || compareValue === priceValue; }
      if (save) { save.textContent = saveLabel || ''; save.hidden = !saveLabel; }
    }
    function setAvailability(available) {
      $$(root, '[data-ss-atc]').forEach(function (button) {
        button.disabled = !available;
        var label = button.querySelector('[data-ss-atc-label]');
        if (label) label.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
      });
    }
    function selectPurchase(input) {
      if (!input) return;
      $$(root, '.ss-card--option').forEach(function (card) { card.classList.toggle('is-selected', card === input.closest('.ss-card--option')); });
      $$(root, '[data-ss-selected-badge]').forEach(function (badge) { badge.hidden = badge.closest('.ss-card--option') !== input.closest('.ss-card--option'); });
      if (sellingPlan) { var planId = input.dataset.planId || ''; sellingPlan.value = planId; sellingPlan.disabled = !planId; }
      setPrice(input.dataset.price, input.dataset.compare, input.dataset.saveLabel);
    }
    function bindPurchaseOptions() {
      $$(root, '[data-ss-purchase-option]').forEach(function (input) {
        if (input.dataset.ssPurchaseReady) return;
        input.dataset.ssPurchaseReady = '1';
        input.addEventListener('change', function () { if (input.checked) selectPurchase(input); });
      });
    }
    function rebuildPlans(selectedVariantId) {
      if (!planOptions) return;
      var template = $$(root, '[data-ss-plan-template]').find(function (candidate) { return candidate.dataset.ssPlanTemplate === selectedVariantId; });
      planOptions.replaceChildren();
      if (template) planOptions.appendChild(template.content.cloneNode(true));
      planOptions.hidden = !planOptions.querySelector('[data-ss-purchase-option]');
      bindPurchaseOptions();
      var oneTime = root.querySelector('[data-ss-purchase-option][value="one-time"]');
      if (oneTime) { oneTime.checked = true; selectPurchase(oneTime); }
    }
    function showVariantMedia(mediaId) {
      if (!mediaId) return;
      var thumb = $$(root, '[data-thumb]').find(function (candidate) { return candidate.dataset.mediaId === mediaId; });
      if (thumb) thumb.click();
    }
    function updateVariant() {
      if (!variantSelect || !variantId) return;
      var option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;
      variantId.value = option.value;
      variantId.dispatchEvent(new Event('change', { bubbles: true }));
      var oneTime = root.querySelector('[data-ss-purchase-option][value="one-time"]');
      if (oneTime) { oneTime.dataset.price = option.dataset.price || ''; oneTime.dataset.compare = option.dataset.compare || ''; oneTime.dataset.saveLabel = option.dataset.saveLabel || ''; }
      if (oneTimePrice) oneTimePrice.textContent = option.dataset.price || '';
      setAvailability(option.dataset.available === 'true');
      rebuildPlans(option.value);
      showVariantMedia(option.dataset.mediaId);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    }
    bindPurchaseOptions();
    var checkedPurchase = root.querySelector('[data-ss-purchase-option]:checked');
    if (checkedPurchase) selectPurchase(checkedPurchase);
    if (variantSelect) variantSelect.addEventListener('change', updateVariant);
  }

  function reveal(scope) {
    var els = $$(scope, '.ss-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function init(scope) {
    $$(scope, '[data-ss-gallery]').forEach(gallery);
    $$(scope, '[data-ss-reel]').forEach(reel);
    $$(scope, '[data-ss-ba]').forEach(ba);
    $$(scope, '[data-ss-ship]').forEach(ship);
    $$(scope, '[data-ss-sticky]').forEach(sticky);
    $$(scope, '[data-ss-product]').forEach(product);
    reveal(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();